module.exports = __webpack_public_path__ + "static/acronyme_alpha-3ecda37b64e062c401cf6d3f58f50aec.png";